import React, { useEffect, useState, useRef } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import FBIntegrationService from '../services/FBIntegrationService';

function EditFBIntegration() {
  const { id } = useParams();
  const toast = useRef(null);

  const [form, setForm] = useState({
    appId:"",
    appSecret:"",
    accessToken:"",
    leadGenId:"",
    isActive: false,
    id: id,
    clientId: "",
  });
  const [formError, setFormError] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFbIntegrationData = async () => {
      try {
        const fbIntegration = await FBIntegrationService.getFBIntegrationById(id);
        setForm(fbIntegration);
      } catch (error) {
        console.error('Error fetching fbIntegration details:', error);
      }
    };
    fetchFbIntegrationData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(prevForm => ({ ...prevForm, [name]: checked }));
    } else if (files) {
      setForm(prevForm => ({ ...prevForm, [name]: files[0] }));
    } else {
      setForm(prevForm => ({ ...prevForm, [name]: value }));
    }
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(form).forEach(key => {
      const value = String(form[key]);
      if (!value.trim() && key !== 'userImage') {
        errors[key] = `Please enter ${key}`;
      }
    });
    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const updateFbIntegration = async () => {
    debugger
    const isValid = validateForm();
    if (!isValid) return;
    
    const formDataToSend = new FormData();
    
    Object.keys(form).forEach(key => {
      if (key === 'userImage' && form[key] instanceof File) {
        formDataToSend.append(key, form[key]);
      } else {
        formDataToSend.append(key, form[key]);
      }
    });
  
    try {
      await FBIntegrationService.updateFBIntegration(id, formDataToSend);

      if (toast.current) {
        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'FBIntegration updated successfully',
          className: 'custom-toast-success',
          life: 3000
        });
      }
      setTimeout(() => {
        navigate(-1); // Navigate after toast shows
      }, 1000);
    } catch (error) {
      console.error("Error updating FBIntegration:", error);
      if (toast.current) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update user',
          className: 'custom-toast-delete',
          life: 3000
        });

      }
    }
  };
  
  return (
    <div>

      <Toast ref={toast} />
      <div className='form-group row'>
         <div className='col-lg-12 float-end'>
                              <div className='col-lg-3 float-end'>
                              </div> 
                   </div>
      </div>
      <br></br>

        <form onSubmit={e => e.preventDefault()}>

          <div className="form-group row">
            <label className="col-lg-2" htmlFor="appId">App Id</label>
            <div className="col-lg-4">
              <input
                
                type="text"
                name="appId"
                id="appId"
                className="form-control"
                value={form.appId}
                onChange={handleInputChange}
              />
              <p className="text-danger">{formError.appId}</p>
            </div>
            <label className="col-lg-2" htmlFor="appSecret">App Secret</label>
            <div className="col-lg-3">
              <input
                
                type="text"
                name="appSecret"
                id="appSecret"
                className="form-control"
                value={form.appSecret}
                onChange={handleInputChange}
              />
              <p className="text-danger">{formError.appSecret}</p>
          </div>
          </div>
          <div className="form-group row">
            <label className="col-lg-2" htmlFor="accessToken">Access Token </label>
            <div className="col-lg-4">
              <input
                
                type="text"
                name="accessToken"
                id="accessToken"
                className="form-control"
                value={form.accessToken}
                onChange={handleInputChange}
              />
              <p className="text-danger">{formError.accessToken}</p>
            </div>
            <label className="col-lg-2" htmlFor="leadGenId">LeadGen Id</label>
            <div className="col-lg-3">
              <input
                
                type="text"
                name="leadGenId"
                id="leadGenId"
                className="form-control"
                value={form.leadGenId}
                onChange={handleInputChange}
              />
              <p className="text-danger">{formError.leadGenId}</p>
          </div>
          </div>
          <div className="form-group row">
          <label className="col-lg-2" htmlFor="isActive">
                Is Active?
              </label>
              <div className="col-lg-4">
                  <input
                      type="checkbox"
                      name="isActive"
                      id="isActive"
                      checked={form.isActive}
                      onChange={handleInputChange}
                    />
              <p className="text-danger">{formError.isActive}</p>
            </div>
           
          </div>
          <div className="form-group row">
            <div className="col-md-12 text-center">
              <button type="submit" className="btn btn-save btn-dark text-white" onClick={updateFbIntegration}>Update</button>
            </div>
          </div>
        </form>
     
    </div>
  );
}

export default EditFBIntegration;